import { getCarrierIcon } from "@redotech/redo-web/carrier/get-carrier-icon";
import { createElement } from "react";

export function CarrierAvatar({ carrier }: { carrier: string }) {
  // Lint rejects <Icon /> from a render-time lookup as an unstable component.
  return createElement(getCarrierIcon(carrier), {
    "aria-label": carrier,
    height: 24,
    style: { display: "block", flexShrink: 0 },
    width: 24,
  });
}
